import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { Link } from "../../ui/Link";
import Image from "next/image";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { barlowCondensed } from "../../../utils/fonts";
import { Button } from "../../uiv7/Button";
import type { Route } from "next";
import type { Offer } from "@local/offer/src/types";
import { DiscountPrice } from "./DiscountPrice";
export interface BestSellersSingleBlockProps {
  product: Offer.BlockListing;
  index: number;
  isVisible: boolean;
  vertical?: boolean;
  market?: string;
}
export const BestSellersSingleBlock = t0 => {
  const $ = _c(44);
  const {
    product,
    index,
    isVisible,
    vertical,
    market
  } = t0;
  const productUrl = `/${market}/product/${product.slug}`;
  const t1 = index > 2 && !isVisible ? "hidden md:block" : "";
  const t2 = vertical ? "" : "rounded-md shadow-md";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cn("group relative h-full w-full", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = vertical ? "aspect-square" : "aspect-video";
  let t5;
  if ($[3] !== t4) {
    t5 = cn("relative mb-1 w-full overflow-hidden bg-gray-100", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = product.image?.url as string;
  const t7 = product.image?.width || 640;
  let t8;
  if ($[5] !== t6 || $[6] !== t7) {
    t8 = getCdnUrl({
      src: t6,
      width: t7
    });
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = product.image?.filename as string;
  const t10 = product.image?.width || 640;
  const t11 = product.image?.height || 640;
  let t12;
  if ($[8] !== t10 || $[9] !== t11 || $[10] !== t8 || $[11] !== t9) {
    t12 = <Image src={t8} alt={t9} width={t10} height={t11} sizes="960px" className="h-full w-full object-cover object-top transition-transform duration-300 ease-in-out group-hover:scale-105 motion-reduce:transition-none" />;
    $[8] = t10;
    $[9] = t11;
    $[10] = t8;
    $[11] = t9;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t12 || $[14] !== t5) {
    t13 = <div className={t5}>{t12}</div>;
    $[13] = t12;
    $[14] = t5;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = vertical ? "" : "px-6";
  let t15;
  if ($[16] !== t14) {
    t15 = cn(t14, "flex flex-1 flex-col justify-between");
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const t16 = vertical ? "" : "text-xl md:text-3xl";
  let t17;
  if ($[18] !== t16) {
    t17 = cn(barlowCondensed.className, "rounded-sm text-xl font-semibold uppercase hover:underline focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 focus-visible:outline-hidden", t16);
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="absolute inset-0" aria-hidden="true" />;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] !== product.name || $[22] !== productUrl || $[23] !== t17) {
    t19 = <h3><Link href={productUrl} className={t17} prefetch={false}>{t18}{product.name}</Link></h3>;
    $[21] = product.name;
    $[22] = productUrl;
    $[23] = t17;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== market || $[26] !== product.prices) {
    t20 = product.prices?.[0] && <DiscountPrice price={product.prices[0]} className="text-sm" market={market} />;
    $[25] = market;
    $[26] = product.prices;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  const t21 = productUrl as Route;
  const t22 = vertical ? "mt-2" : "my-4";
  let t23;
  if ($[28] !== t22) {
    t23 = cn("z-raised relative w-full! max-w-full text-lg font-medium uppercase md:font-normal", t22);
    $[28] = t22;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== t21 || $[31] !== t23) {
    t24 = <Button as="link" href={t21} prefetch={false} aria-hidden="true" tabIndex={-1} className={t23}>Shop Now</Button>;
    $[30] = t21;
    $[31] = t23;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  let t25;
  if ($[33] !== t15 || $[34] !== t19 || $[35] !== t20 || $[36] !== t24) {
    t25 = <div className={t15}>{t19}{t20}{t24}</div>;
    $[33] = t15;
    $[34] = t19;
    $[35] = t20;
    $[36] = t24;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== t13 || $[39] !== t25) {
    t26 = <div className="flex h-full w-full flex-col justify-start md:justify-between">{t13}{t25}</div>;
    $[38] = t13;
    $[39] = t25;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t26 || $[42] !== t3) {
    t27 = <article className={t3}>{t26}</article>;
    $[41] = t26;
    $[42] = t3;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  return t27;
};